import { Form, Formik } from 'formik';
import { FC } from 'react';
import * as Yup from 'yup';

import AuthWrapper from 'components/modules/AuthWrapper';
import Button from 'components/primitives/Button';
import TextInput from 'components/primitives/TextInput';
import { ForgotPasswordProps } from './ForgotPassword.props';

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
});

const initialValues = {
  email: '',
};

const ForgotPasswordView: FC<ForgotPasswordProps> = ({
  onSubmit,
  isLoading,
  goToLogin,
}) => {
  const ForgotPasswordForm = () => {
    return (
      <div>
        <h2 className="text-center">Forgot Password</h2>
        <p className="font-secondary text-center mt-1">
          Enter your email address and we'll send you a link to reset your
          password.
        </p>
        <div className="justify-center items-center place-items-center m-4">
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validateOnChange={false}
            validateOnBlur={false}
            validationSchema={validationSchema}>
            <Form className="flex flex-col justify-center w-full">
              <TextInput
                type="email"
                name="email"
                placeholder="Enter your email"
              />
              <Button
                isLoading={isLoading}
                id="open-btn"
                type="submit"
                variant="solid"
                colorScheme="primary"
                className="w-full mt-5">
                Send Reset Link
              </Button>
            </Form>
          </Formik>
        </div>

        <div className="flex flex-row justify-center mt-5 text-gray-600">
          <p className="text-sm">Remember your password?&nbsp;</p>
          <p
            onClick={goToLogin}
            className="text-sm text-primary-500 cursor-pointer">
            Log in
          </p>
        </div>
      </div>
    );
  };

  return (
    <AuthWrapper>
      <ForgotPasswordForm />
    </AuthWrapper>
  );
};

export default ForgotPasswordView;
